<template>
	<div class="player-container flex items-center overflow-unset ml-35 pb-20">
		<SoundPlayer :url="soundtrackURL" />
		<div style="flex-grow: 1">
			<OptionsSelect
				v-loading.disabling="loading"
				:value="innerValue"
				:options="soundtracks"
				class="music-list medium-sm-text mr-10"
				@input="onInnerValueChange"
			/>
		</div>
	</div>
</template>

<script>
import SoundPlayer from './SoundPlayer'
import { OptionsSelect } from '~/components/interface'

export default {
	name: 'SoundSelector',
	components: { SoundPlayer, OptionsSelect },
	props: {
		value: {
			type: String,
			required: true
		}
	},
	data: () => ({
		loading: false,
		innerValue: '',
		soundtracks: [],
		soundtrackURL: ''
	}),
	watch: {
		value: {
			immediate: true,
			handler (val) {
				this.innerValue = val
			}
		}
	},
	created () {
		this.fetchSoundtracks()
	},
	methods: {
		onInnerValueChange (value) {
			this.soundtrackURL = this.soundtracks
				.filter(item => item.id === value)
				.map(item => item.url)
				.toString()

			this.$emit('input', value)
		},

		fetchSoundtracks () {
			this.loading = true

			this.$axios.$get('/api/v1/users/me/clips/static')
				.then(response => response.data?.attributes?.soundtrack)
				.then(this.formatSoundtracks)
				.then((tracks) => {
					this.loading = false
					this.soundtracks = tracks
					this.soundtrackURL = this.soundtracks
						.filter(item => item.id === this.innerValue)
						.map(item => item.url)
						.toString()
				})
				.catch(() => {
					this.loading = false
					this.$log.error('Failed to load supported soundtracks')
				})
		},
		formatSoundtracks (soundtrack) {
			return Object.entries(soundtrack).map(([genre, url]) => ({
				id: genre,
				title: this.$tc(`modals.highlightCreating.soundtracksTitle.${genre}`),
				url: url.track
			}))
		}
	}
}
</script>

<style lang="scss">
.player-container {
  .music-list {
    .text-input {
      border-bottom: unset !important;
    }
    select.text-input {
      background-image: url("~/assets/icons/ic-notification-arrow.svg");
      background-size: 12px 10px;
      color: $light-blue;
    }
  }
}
</style>
